import { alpha } from '@mui/material/styles'

const withAlphas = (color: any) => {
  return {
    ...color,
    alpha4: alpha(color.main as string, 0.04),
    alpha8: alpha(color.main as string, 0.08),
    alpha12: alpha(color.main as string, 0.12),
    alpha30: alpha(color.main as string, 0.3),
    alpha50: alpha(color.main as string, 0.5),
  }
}

export const neutral = {
  50: '#F8F9FA',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927',
}

export const indigo = withAlphas({
  lightest: '#4055F2',
  light: '#1A37EF',
  main: '#6366F1',
  dark: '#0A1A85',
  darkest: '#050F4C',
  contrastText: '#FFFFFF',
})

export const bubbleBlue = withAlphas({
  lightest: '#E0F2FB',
  light: '#66A2E8',
  main: '#0d70aa',
  dark: '#0A5A85',
  darkest: '#073F5C',
  contrastText: '#FFFFFF',
})

export const insightAiBlack = withAlphas({
  moreLight: '#e6e6e8',
  lightest: '#e6e6e8',
  light: '#3b3b4a',
  main: '#0b0b1d',
  dark: '#232333',
  darkest: '#000000',
  contrastText: '#FFFFFF',
})

/*
        black: {
          DEFAULT: "#0b0b1d",
          50: "#ffffff",
          100: "#e6e6e8",
          200: "#ceced1",
          300: "#b5b5bb",
          400: "#9d9da4",
          500: "#85858e",
          600: "#6c6c77",
          700: "#545460",
          800: "#3b3b4a",
          900: "#232333",
        },
*/

export const success = withAlphas({
  lightest: '#F0FDF9',
  light: '#3FC79A',
  main: '#10B981',
  dark: '#0B815A',
  darkest: '#134E48',
  contrastText: '#FFFFFF',
})

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#75C5D1',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF',
})

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF',
})

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#F04438',
  main: '#F04438',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF',
})
